import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  name: (i) => `${faker.location.cityName()}: Computer ${i + 1}`,

  hostname: null,
  state: 'disconnected',
  externalResourceVendor: 'printnode',

  externalResourceUid: (i) => `${i * 4 + 1000}`,
  createdAt: () => new Date(),

  withOptions: trait({
    afterCreate(printerConnection, server) {
      const parentId = printerConnection.externalResourceUid;

      server.createList('printer-connection-option', 3, { parentId });
    },
  }),
});
